<template>
	<div class="row font_detail">
		<div class="col-xs-4 font-bold">
			<label>{{ description }}</label>
		</div>
		<div class="col-xs-1"> : </div>
		<div class="col-xs-6">
			{{ descDetail }}
		</div>
	</div>
</template>

<script>
export default {
  name: 'calendar_detail',
  props: ['description', 'descDetail']
}
</script>


// WEBPACK FOOTER //
// calendar_detail.vue?1cd0170d